import img1 from "../images/1.jpg";
import img2 from "../images/2.jpg";
import img3 from "../images/3.jpg";

export const images=[

    {img:img1},
    {img:img2},
    {img:img3}
]